import { render, staticRenderFns } from "./ResourceInstanceWriteDialog.vue?vue&type=template&id=2a3fb561&"
import script from "./ResourceInstanceWriteDialog.vue?vue&type=script&lang=js&"
export * from "./ResourceInstanceWriteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports